<section class="secondSection">
  <div class="mid-layout">
    <div class="row">
      <div class="col-md-4" *ngFor="let data of bannerFeatures">
        <div class="row">
          <div class="col-md-2"><img class="number-image" src="{{path}}{{data.Icon_Details}}"></div>
          <div class="col-md-10 guidedCost">
            <span class="title-description">{{data.Title_Description}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>